<div class="analysis-page">

  <div class="analysis-header">
    <div>
      <h1>Disinformation Analysis</h1>
      <p class="subtitle">
        Analyze texts for Russian propaganda and false information using a narrative knowledge base and an LLM-based assessment.
      </p>

    </div>
    <div class="badge">
      Beta
    </div>
  </div>

  <div class="analysis-layout">
    <!-- LINKER BEREICH: Eingabe -->
    <section class="panel input-panel">
      <h2>Text for Analysis</h2>
      <p class="hint">
        Paste an article, tweet, or comment. The text is retained only for this analysis.
      </p>

      <div class="textarea-wrapper">
        <textarea
          [(ngModel)]="text"
          rows="12"
          placeholder="Paste text here..."
        ></textarea>
      </div>

      <div class="button-row">
        <button class="btn primary" type="button" (click)="analyze()">
          Analyze
        </button>
        <button class="btn ghost" type="button" (click)="loadExample()">
          Load example text
        </button>
      </div>

      <div class="status-row">
        <span class="status loading" *ngIf="loading">Analyzing…</span>
        <span class="status error" *ngIf="error">{{ error }}</span>
      </div>
    </section>

    <!-- RECHTER BEREICH: Ergebnis -->
    <section class="panel result-panel" *ngIf="result">
      <!-- Gesamtbewertung -->
      <div class="card highlight-card">
        <div class="card-header">
          <h2>Overall Result</h2>
          <span class="pill" [ngClass]="result?.finalLabel">
            {{ labelToText(result?.finalLabel) }}
          </span>
        </div>
        <p class="card-text">
          The combination of known narratives and the LLM assessment produces this overall result.
        </p>
      </div>

      <!-- Bekanntes Narrativ -->
      <div class="card" *ngIf="result?.knownNarrative">
        <div class="card-header">
          <h3>Known Narrative Detected</h3>
          <span class="pill pill-soft">Knowledge Base</span>
        </div>
        <div class="card-body">
          <div class="meta-row">
            <span class="label">ID</span>
            <span>{{ result.knownNarrative?.id }}</span>
          </div>
          <div class="meta-row">
            <span class="label">Tag</span>
            <span>{{ result.knownNarrative?.tag }}</span>
          </div>
          <div class="meta-row">
            <span class="label">Description</span>
            <span>{{ result.knownNarrative?.narrativeText }}</span>
          </div>
          <div class="meta-row">
            <span class="label">Similarity</span>
            <span>{{ result.knownNarrative?.similarity | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>


      <!-- LLM-Einschätzung (nur wenn KEIN bekanntes Narrativ erkannt wurde) -->
      <div class="card" *ngIf="result?.llmAssessment && !result?.knownNarrative">

        <div class="card-header">
          <h3>LLM Assessment</h3>
          <span class="pill pill-soft">Model Output</span>
        </div>
        <div class="card-body">
          <div class="meta-row">
            <span class="label">Label</span>
            <span>{{ labelToText(result.llmAssessment?.label) }}</span>
          </div>
          <!--
          <div class="meta-row">
            <span class="label">Probability</span>
            <span>
              {{ (result.llmAssessment?.probability || 0) * 100 | number:'1.0-1' }} %
            </span>
          </div>
          !-->
          <div class="meta-row">
            <span class="label">Rationale</span>
            <span>{{ result.llmAssessment?.reason }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
